export enum SmartZoneSendState{
  CheckPolygon = 0,
  WaitingForGreyListCreation = 1,
  EnsureGreyListCreated = 2,
  ReadyToCreateSend = 3,
  Refreshing = 4,
  WaitingForMessageEntry = 5,
  WaitingForRecipientSelection = 6,
  WaitingForAdminManualReview = 7,
  WaitingForPayment = 8,
  WaitingForAdminManualPaymentReview = 9,
  Paid = 10,
  /** Docs: WaitingForClosure — reportable for daily statistics */
  SentToProvider = 11,
  /** Docs: Closed — reportable for daily statistics */
  Finished = 12,
  Rejected = 13,
  Failed = 14,
  Expired = 15,
  WaitingForUserConfirmation = 16
}

/** Pishgam delivery status codes for smart-zone daily statistics */
export enum SmartSmsStatisticsSendStatus {
  DeliveredToPhone = 1,
  NotDeliveredToPhone = 2,
  SentToOperator = 3,
  NotDeliveredToOperator = 4,
  BlackList = 5,
  InvalidSenderLine = 6,
}

export enum TargetTime{
  Past = 1,
  Future = 2
}

export enum SmartZoneSendMobileOs {
  Android = 1,
  IOS = 2,
  Other = 4
}

export enum SmartZoneSendResidenceState {
  Resident = 1,
  Guest = 2
}
